import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { listResources } from '../redux/actionCreators/resources'
import PageItem from './bootstrap/PageItem'
import Inflection from 'inflection'

class Resources extends Component {
  static defaultProps = {
    idField: "id",
    fields: ["id"],
    listParams: {}
  }
  
  constructor(props) {
    super(props)
    this.state = {
      firstRecordSet: true,
      firstRecordId: null,
      lastRecordId: null
    }
  }
  
  componentDidMount() {
    if (this.props.canMakeResourceRequest) this.props.listResources(this.props.listParams)
  }
  
  componentDidUpdate() {
    if (this.props.canMakeResourceRequest && !this.props.resourceLoaded) this.props.listResources(this.props.listParams)
    
    if (this.props.resourceLoaded) {
      if (this.state.firstRecordSet) {
        this.setState({
          firstRecordSet: false,
          firstRecordId: this.props.resources[0][this.props.idField]
        })
      } else if (this.props.resources.length < 20) {
        // this.setState({
          // lastRecordId: this.props.resources[this.props.resources.length - 1]
        // })
      }
    }
  }
  
  previousPage() {
    this.props.listResources({
      ...this.props.listParams,
      _before: this.props.resources[0][this.props.idField]
    })
  }
  
  nextPage() {
    this.props.listResources({
      ...this.props.listParams,
      _after: this.props.resources[this.props.resources.length - 1][this.props.idField]
    })
  }
  
  render() {
    if (!this.props.resourceLoaded) return (
      <div>Loading</div>
    )
    
    return (
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              {this.props.fields.map((field, index) => {
                return (
                  <th key={index}>{Inflection.titleize(field)}</th>
                )
              })}
            </tr>
          </thead>
          <tbody>
            {this.props.resources.map((resource, index) => {
              return (
                <tr key={resource[this.props.idField]}>
                  {this.props.fields.map((field, index) => {
                    if (field === this.props.idField) {
                      return (
                        <td key={index}><Link to={`/${this.props.resourceType}/${resource[this.props.idField]}`} >{resource[this.props.idField]}</Link></td>
                      )
                    }
                    if (field.slice(-3) === "_id") {
                      const model = Inflection.pluralize(field.slice(0, field.length - 3))
                      return (
                        <td key={index}><Link to={`/${model}/${resource[field]}`} >{resource[field]}</Link></td>
                      )
                    }
                    return (
                      <td key={index}>{resource[field]}</td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </table>
        <nav>
          <ul className="pagination">
            <PageItem onClick={() => {this.previousPage()}} label="Previous" disabled={ this.props.resources[0][this.props.idField] === this.state.firstRecordId } />
            <PageItem onClick={() => {this.nextPage()}} label="Next" disabled={ this.props.resources[this.props.resources.length - 1][this.props.idField] === this.state.lastRecordId } />
          </ul>
        </nav>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  resourceLoaded: function() {
    const resources = state.api[ownProps.resourceType] || {}
    const list = resources.list || {}
    return list.isLoaded || false
  }(),
  canMakeResourceRequest: function() {
    const resources = state.api[ownProps.resourceType] || {}
    const list = resources.list || {}
    return state.oidc.user && !state.oidc.user.expired && !(list.isLoading || false) && !(list.isError || false)
  }(),
  resources: function() {
    const resources = state.api[ownProps.resourceType] || {}
    const list = resources.list || {}
    const keys = list.keys || []
    
    return keys.map((key) => {
      return resources[key]
    })
  }()
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  listResources: (params = {}) => {dispatch(listResources(ownProps.resourceType, params, ownProps.idField || "id"))}
})

export default connect(
  mapStateToProps,
  mapDispatchToProps 
)(Resources)